module.exports = __webpack_public_path__ + "static/media/viviendas.881a7fda.jpg";